<template>
  <div class="form-input" :class="slider ? 'slider' : null">
    <label class="input-label">
      {{ label }}
    </label>
    <div class="input-wrapper">
      <input type="number" class="input" :value="getter" @input="onInput" />
      <div class="input-unit">{{ unit }}</div>
      <input
        v-if="slider"
        type="range"
        class="input-slider"
        :min="sliderMin"
        :max="sliderMax"
        :step="sliderStep"
        :value="getter"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    getter: {
      required: true
    },
    setter: {
      required: true,
      type: Function
    },
    label: {
      required: true,
      type: String
    },
    unit: {
      required: true,
      type: String
    },
    slider: {
      required: false,
      type: Boolean
    },
    sliderMin: {
      default: 0.1,
      type: Number
    },
    sliderMax: {
      default: 3,
      type: Number
    },
    sliderStep: {
      default: 0.1,
      type: Number
    }
  },
  methods: {
    onInput(e) {
      this.setter(e.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.form-input {
  .input-label {
    display: block;
    font-size: var(--fs-15);
    margin-bottom: var(--spacing-sm);
  }

  .input-wrapper {
    font-size: var(--fs-18);
    background: var(--clr-white);
    border: 1px solid var(--clr-light);
    border-radius: 4px;
    display: flex;
    align-items: center;
    position: relative;

    .input {
      padding: var(--spacing-sm) 0 var(--spacing-sm) var(--spacing-md);
      background: transparent;
      border: none;
      width: 100%;
    }

    .input:focus {
      outline: none;
    }

    .input-unit {
      font-weight: var(--fw-bold);
      padding: var(--spacing-sm) var(--spacing-md);
    }

    &:focus-within {
      border-color: var(--clr-green);
    }
  }
}

.form-input.slider {
  .input-wrapper {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .input-slider {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    margin: 0;
    transform: translatey(50%);
  }
}
</style>